import styled, { css } from 'styled-components';
import {
  black,
  exactWhite,
  gray,
  HOVER_CELL_COLOR,
  lightGray,
  NORMAL_CELL_COLOR,
  orange,
  WEBDA_DARK_BG,
} from '../../../../utils/style/colors';
import Slider from 'react-slick';
import { languageDirection } from 'i18n';

// const CardWidthDesktop = {
//   B: 170,
//   M: 170,
//   S: 100,
// };
// const CardWidthMobile = {
//   B: 150,
//   M: 115,
//   S: 80,
// };
const CardWidthShineDesktop = {
  B: 200,
  M: 200,
  S: 130,
};
const CardHeightDesktop = {
  B: 210,
  M: 180,
  S: 120,
};
const CardHeightMobile = {
  B: 195,
  M: 180,
  S: 120,
  MB: 180, //MobileBot
};
interface ItemProps {
  poster: boolean;
  round: boolean;
  mobileSize: string;
  desktopSize: string;
  background?: string;
  shine?: boolean;
}

export const Item = styled('div')<ItemProps>`
  width: 95% !important;
  position: relative;
  flex: none;
  color: ${black};
  display: flex;
  transition: all 0.3s ease;
  align-items: center;
  margin-bottom: 1.5rem;
  justify-content: flex-start;
  border-radius: 2.5rem !important;
  gap: 0.5rem;
  width: ${(props) =>
    props.shine && CardWidthShineDesktop[props.desktopSize] + 'px'};
  height: ${(props) => CardHeightDesktop[props.desktopSize] + 'px'} !important;
  @media only screen and (max-width: 450px) {
    height: ${(props) =>
      props.displayMode === 'md' &&
      CardHeightMobile[props.mobileSize] + 'px'} !important;
  }
  ${({ background }) =>
    background
      ? `background-color: ${background}; 
  `
      : ''}
  flex-direction: column;
  margin: 0.5rem auto;

  ${(props) =>
    props.displayMode === 'xlg' &&
    props.cellType === 'md' &&
    `
    display: flex !important;
    flex-direction: row !important;
    height: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 1rem !important;
  `}

  ${(props) =>
    props.displayMode === 'xlg' &&
    props.cellType === 'lg' &&
    `
    height: 100% !important;
    margin: 0 !important;
    width: 100% !important;
  `}

${(props) =>
    props.displayMode === 'lg' &&
    props.cellType === 'md' &&
    `
    height: 100% !important;
    width: 100% !important;
    margin: 0 !important;
  `}

  ${(props) =>
    props.displayMode === 'lg' &&
    props.cellType === 'lg' &&
    `
    height: 100% !important;
    width: 100% !important;
    margin: 0 !important;
  `}

  ${(props) =>
    props.displayMode === 'md' &&
    `
      width: 100% !important;
      margin: 0 !important;
    `}


  ${(props) =>
    props.shine &&
    `
    margin: 0 !important;
    height: 100% !important;
    width: 100% !important;
  `}
`;

export const CardHeader = styled('div')`
  display: flex;
  align-items: center;
  color: ${black} !important;
  position: relative;
`;
export const EmptyPlaceHolder = styled('div')`
  display: flex;
  align-items: center;
  padding: 30px;
  justify-content: center;
`;
export const CardHeaderDash = styled('span')`
  height: 0;
  border-top: 1px dashed #00897b;
  flex-grow: 1;
  opacity: 0.6;
  margin: 10px 10px;
`;
export const CardHeaderText = styled('span')`
  line-height: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1rem 0 2rem;
  transition: transform 0.5s ease-in-out;
`;

export const Card = styled('div')<ItemProps>`
  height: fit-content;
  margin: 1em;
  margin-top: 1rem;
  display: flex;
  background: var(--exact-white);
  box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    flex: none;
  }
`;

export const ItemDistance = styled('span')<ItemProps>`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: ${gray};
`;
export const Filled = styled('span')<ItemProps>`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: green;
  color: ${black};
  direction: rtl;
  display: flex;
  flex-direction: row-reverse;
  padding: 1px 5px;
  position: absolute;
  top: ${(props) => CardHeightDesktop[props.desktopSize] - 75 + 'px'};
  @media only screen and (max-width: 450px) {
    top: ${(props) => CardHeightMobile[props.desktopSize] - 75 + 'px'};
  }
`;
export const ItemName = styled('span')<ItemProps>`
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  word-break: break-word;
  overflow: hidden;
  transition: all 1s ease;
  border-radius: 0 0 16px 16px;
  text-overflow: ellipsis;
  color: ${black};
  padding: ${(props) =>
    props.displayMode === 'lg' ||
    (props.displayMode === 'xlg' && props.cellType === 'lg')
      ? '0 1rem'
      : '0 0.5rem'};

  &:hover {
    max-height: 100%;
    height: auto;
    min-height: 45px;
    /* background-color: rgba(255, 255, 255, 0.91); */
    //overflow: hidden;
    z-index: 1000;
  }

  font-style: normal;
  font-weight: 400;

  font-size: 14px;
  line-height: 18px;
  @media only screen and (max-width: 450px) {
    font-size: 12px;
    line-height: 16px;
    ${(props) =>
      props.displayMode === 'xlg' &&
      props.cellType === 'md' &&
      `
    font-size: 1.25rem !important;
    line-height: 1.75 !important;
    
  `}

    ${(props) =>
      props.displayMode === 'xlg' &&
      props.cellType === 'lg' &&
      `
    padding: 0 1rem !important;
    line-height: 1.75 !important;
    font-size: 1.25rem !important;
  `}
  }
  text-align: center;
  width: 100%;
  height: 45px;
  align-items: center;
  flex-shrink: 0;
  display: inline-grid;
  ${({ background }) =>
    background
      ? `color: ${exactWhite};
      font-weight: 400;`
      : ''}

  ${(props) =>
    props.displayMode === 'xlg' &&
    props.cellType === 'md' &&
    `
    position: relative;
    bottom: auto;
    left: auto;
    width: 50%;
    height: 100% !important;
    font-size: 1.25rem;
    line-height: 1.75;
    text-align: start;
  `}

  ${(props) =>
    props.displayMode === 'xlg' &&
    props.cellType === 'lg' &&
    `
    height: 20% !important;
    min-height: 50px;
    font-size: 1.75rem;
    line-height: 1.5;
    
    &:hover { 
      max-height: 100%;
    }
  `}

${(props) =>
    props.displayMode === 'lg' &&
    props.cellType === 'md' &&
    `
  `}

  ${(props) =>
    props.displayMode === 'lg' &&
    props.cellType === 'lg' &&
    `
  `}

  ${(props) =>
    props.displayMode === 'md' &&
    `
      display: inline-block !important;
      overflow: hidden !important;
      padding: 0.5rem 1rem !important;
    `}

  @media only screen and (max-width: 450px) {
    height: ${(props) => (props.shine ? '25' : '45')}px;
    font-size: 12px;

    ${(props) =>
      props.displayMode === 'md' &&
      `
      text-overflow: ellipsis;
    `}
  }
`;

export const ItemImage = styled('img')<ItemProps>`
  width: 100%;
  // height: 74%;
  background: ${(props) => (props.round ? '' : 'rgba(0, 0, 0, 0.03)')};
  ${({ background }) => (background ? `background-color: ${background} ;` : '')}
  border-radius: ${(props) =>
    props.round ? '50%' : props.shine ? '1.5rem' : '1.5rem'};
  object-fit: ${(props) => (props.poster ? 'cover' : 'contain')};
  padding: ${(props) => (props.poster && !props.round ? '0px' : '10px')};
  height: ${(props) =>
    CardHeightDesktop[props.desktopSize] - (props.shine ? 20 : 50) + 'px'};

  ${(props) =>
    props.displayMode === 'md' &&
    `
    padding: 1rem !important;
    border-radius: 2.5rem !important;
  `}

  ${(props) =>
    props.displayMode === 'xlg' &&
    props.cellType === 'md' &&
    `
    width: 50% !important;
    height: 100% !important;
  `}
  ${(props) =>
    props.displayMode === 'xlg' &&
    props.cellType === 'lg' &&
    `
    height: 80% !important;
    padding: 1rem !important;
    border-radius: 2.5rem;
  `}

${(props) =>
    props.displayMode === 'lg' &&
    props.cellType === 'md' &&
    `
    padding: 1rem !important;
    border-radius: 2.5rem;
  `}
  ${(props) =>
    props.displayMode === 'lg' &&
    props.cellType === 'lg' &&
    `
    padding: 1rem !important;
    border-radius: 2.5rem;
  `}

  ${(props) => props.shine && 'height: calc(100% - 45px) !important;'}

  @media only screen and (max-width: 450px) {
    height: 130px;
  }
`;

export const SectionContainer = styled.div<ItemProps>`
  margin: ${(props) => (props.shine ? '0' : '0 0 2rem')};
  padding: ${(props) => (props.shine ? '0 1.25rem' : '0.5rem 1.25rem')};
  @media only screen and (min-width: 769px) {
    padding: ${(props) => (props.shine ? '0' : '1rem 2rem')};
  }
`;

export const Square = styled.div`
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 2px;
  background: ${orange};
  margin-inline-end: 0.5rem;
`;

export const HeaderContent = styled.div`
  color: ${black}!important;
  font-weight: normal !important;
  font-size: 2rem !important;
  line-height: 2.75rem !important;
  @media only screen and (min-width: 769px) {
    font-size: 2rem !important;
  }
`;

export const RowContainer = styled.div`
  min-height: 4rem;
  display: flex;
  align-items: center;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 6px 6px 10px 5px rgba(0, 0, 0, 0.1);
  background: ${NORMAL_CELL_COLOR};
`;

export const BadgeContainer = styled.div`
  padding-inline-start: 1rem;
  width: 10rem;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const BadgeImage = styled.img`
  height: 2rem;
  width: 2rem;
  object-fit: contain;
`;

export const ContentContainer = styled.a`
  border-radius: 1rem;
  min-height: 4rem;
  width: 15rem;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  margin-inline-start: -6rem;
  padding: 0.5rem;
  color: ${black};
  font-weight: 500;
  font-size: 1rem;
  overflow: hidden;
  background: linear-gradient(
    to ${languageDirection() === 'rtl' ? 'right' : 'left'},
    #5151511c,
    rgba(255, 255, 255, 0.2) 70%
  );

  @media only screen and (min-width: 600px) {
    font-size: 1.25rem !important;
    padding-top: 1rem;
  }
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &:hover {
    cursor: pointer;
  }
`;

export const ColumnRowContainer = styled.div<ItemProps>`
  direction: ${(props) => props.theme.direction};
  //width: 100%;
  display: flex;
  flex-direction: ${(props) => props.direction};
  gap: 2rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
  //justify-content: ${(props) => (props.shine ? 'center' : undefined)};
  justify-content: center;

  @media only screen and (max-width: 450px) {
    justify-content: center;
  }
`;

export const CustomSlider = styled(Slider)`
  & .slick-next {
    transform: translateY(-25px) !important;
    &:before {
      content: ${(props) =>
        props.theme.direction === 'rtl' ? '"←"' : '"→"'} !important;
      font-size: 3rem !important;
    }
  }

  & .slick-prev {
    transform: translateY(-25px) translateX(-18px) !important;
    &:before {
      content: ${(props) =>
        props.theme.direction === 'rtl' ? '"→"' : '"←"'} !important;
      font-size: 3rem !important;
      margin-bottom: 2rem;
    }
  }

  & .slick-next:before,
  & .slick-prev:before {
    color: ${lightGray} !important;
  }

  & .slick-dots button:before {
    font-size: 0.8rem !important;
  }

  & .slick-dots {
    overflow: hidden;
    max-height: 20px;
  }
`;

export const FixedContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${(props) => (props.isSelected ? '10000000' : '0')};
  opacity: ${(props) => (props.isSelected ? '1' : '0')};
  transform: scale(1.5);
  transition: all 0.5s cubic-bezier(0.61, -0.02, 0.27, 1.26);
`;

export const ExpandedContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props.isSelected ? WEBDA_DARK_BG : '#efefef')};
  //visibility: ${(props) => (props.isSelected ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isSelected ? '' : 'scale(0.6)')};
  height: ${(props) => (props.isSelected ? '100%' : '50%')};
  opacity: ${(props) => (props.isSelected ? '1' : '0')};
  width: 100%;
  padding: 1rem 0;
  transition: all 0.5s cubic-bezier(0.61, -0.02, 0.27, 1.26);
`;

export const ExpandedContent = styled.div`
  transform: scale(0.666);
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0.75rem auto;
  gap: 3rem;
  overflow: hidden auto;
  width: 100%;
  max-width: ${(props) => (props.isFullScreen ? '100%' : '1024px !important')};
`;

export const BotContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;

  @media screen and (min-width: 600px) {
    width: 80%;
    max-width: 1024px;
  }

  @media screen and (max-width: 600px) {
    gap: 1rem;
  }
`;

export const ContentRow = styled.div`
  flex: 1;
  width: 100%;
  display: grid;

  grid-template-columns: ${({ displayMode }) =>
    displayMode === 'xlg'
      ? 'repeat(2,  minmax(0, 1fr))'
      : displayMode === 'lg'
        ? 'repeat(4, minmax(0, 1fr))'
        : 'repeat(3, minmax(0, 1fr))'};

  grid-auto-rows: ${({ displayMode }) =>
    displayMode === 'xlg'
      ? '16rem'
      : displayMode === 'lg'
        ? '14rem'
        : 'minmax(0, 1fr)'};
  gap: 2rem;

  @media screen and (max-width: 600px) {
    grid-template-columns: ${({ displayMode, shine }) =>
      displayMode === 'xlg'
        ? 'repeat(1, minmax(0, 1fr))'
        : displayMode === 'lg' && !shine
          ? 'repeat(2, minmax(0, 1fr))'
          : displayMode === 'lg' && shine
            ? 'repeat(2, minmax(0, 1fr))'
            : 'repeat(1, minmax(0, 1fr))'} !important;

    grid-auto-rows: ${({ displayMode }) =>
      displayMode === 'xlg' ? '16rem' : 'minmax(0, 1fr)'};
    gap: 1rem;
  }
`;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

export const BoxHeader = styled.div`
  position: relative;
  font-size: 1.6rem;
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.h2`
  position: relative;
  transition: all 0.3s ease-in-out;
  height: 25%;
  text-align: center;
  margin: 0.5rem auto;

  ${(props) =>
    props.showBack &&
    `
    right: 0;
  `}
`;

export const HeaderLogo = styled.img`
  height: 2.5rem !important;
  width: 2.5rem !important;
  margin: 0.5rem auto;
  border-radius: 0.5rem;
`;

export const BackContainer = styled.div`
  font-weight: bold;
  display: flex;
  width: 100%;
  position: sticky;
  top: 2.25rem;
  left: 0;
  z-index: 3;
  color: ${black};

  @media screen and (max-width: 600px) {
    width: 90%;

    top: 0.75rem;
  }
`;

export const Back = styled.div`
  transition: all 0.1s ease-in;
  font-size: 1rem;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  background: ${gray};
  color: ${black};
  border-radius: 15px;

  @media screen and (max-width: 600px) {
    font-size: 1rem;
  }
  visibility: visible;
  opacity: 1;
`;

export const More = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in;
  font-weight: bold;
  cursor: pointer;
  margin-top: 1rem;
  color: ${black};

  &:hover {
    transform: scale(1.15) translateX(-0.15rem);

    & > i {
      transform: translateX(-4px);
    }
  }
`;

export const ChatbotBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: url('/assets/chat-bg.png') no-repeat center center / cover;
`;

export const ChatBotContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  color: var(--exact-white);
`;

export const ChatBotLogo = styled.img`
  height: 4rem;
  width: 4rem;
  border-radius: 1rem;
`;

export const ChatBotHeader = styled.h3`
  font-weight: bold;
  font-size: 1.2rem;
`;

export const ChatBotSubHeader = styled.p`
  color: ${black};
  flex: 1;
`;

export const ChatBotButton = styled.div`
  width: 100%;
  border: 1px solid var(--exact-white);
  padding: 0.75rem;
  border-radius: 10rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
  height: 4rem;
  background: ${black};
`;

export const ChatSendIcon = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 10rem;
  background: ${black};
  color: var(--exact-white);
  flex: 2.5rem;
`;

export const ChatBotQuestion = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  color: var(--exact-white);
  padding-inline-start: 0.5rem;
  flex-wrap: nowrap;
  flex-basis: calc(100% - 2.5rem);
`;

export const ChartContainer = styled.div`
  width: 100%;

  & * {
    box-shadow: none;

    @media screen and (max-width: 600px) {
      margin: 0.5rem 0;
    }
  }
`;

export const Cell = styled.a`
  position: relative;
  text-decoration: none;
  border-radius: 2.5rem !important;
  height: 100%;
  width: 100%;
  box-shadow: 6px 6px 10px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.1s ease-in;
  overflow: hidden;
  z-index: 1;

  ${(props) =>
    props.isChatbot &&
    css`
      background: url('/assets/chat-bg.png') no-repeat center center / cover;
    `}

  /* &::before {
    content: '';
    position: absolute;
    inset: -20px;
    border-radius: inherit;
    background: red;
    opacity: 0;
    transition: opacity 0.25s ease;
    z-index: -1;
  }

  &:hover::before {
    opacity: 1;
  } */

  &:hover {
    transform: scale(1.025);
    ${(props) =>
      !props.isChatbot &&
      css`
        background: ${HOVER_CELL_COLOR};
      `}
  }
`;

export const LGHorizontalCell = styled(Cell)`
  grid-column: span 2;
  grid-row: span 1;
`;

export const LGNormalCell = styled(Cell)`
  grid-column: span 1;
  grid-row: span 1;
`;

export const MDCell = styled(Cell)`
  grid-column: span 1;
  grid-row: span 1;
`;

export const XLGVerticalCell = styled(Cell)`
  grid-column: span 1;
  grid-row: span 2;
  background: ${(props) =>
    props.isDarkMode
      ? 'url("/assets/xlg-background.png") no-repeat center center / cover'
      : ''};

  &:hover {
    background: ${(props) =>
      props.isDarkMode
        ? 'url("/assets/xlg-background.png") no-repeat center center / cover'
        : ''};
  }
`;

export const XLGNormalCell = styled(Cell)`
  grid-column: span 1;
  grid-row: span 1;
`;
